import React from 'react';
import { Box, styled, Typography } from '@mui/material';
// Components
import { AuthLayout, useAuthContext } from '@components/auth';
import { AppCard, Failed, Logout, Token } from '@components';
import { Api, getFile, getToken, setLogos } from '@/utils';
import { ClockLoader } from 'react-spinners';

const Wrap = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  paddingTop: theme.spacing(5),
  minHeight: 'calc(100vh - 63px)',
  maxWidth: 480,
  margin: '0 auto',

  '& > *': {
    width: '100%',
  },
}));

const logo = () => {
  if (import.meta.env.VITE_SITE === 'Paybilt') {
    return '/images/paybilt.png';
  } else {
    return '/images/payper.png';
  }
};

const Result = () => {
  const [token, setToken] = React.useState('');
  const [privacy, setPrivacy] = React.useState('');
  const [terms, setTerms] = React.useState('');
  const [redirectUrl, setRedirectUrl] = React.useState('');
  const [wait, setRedirecting] = React.useState(false);
  const [hasRedirect, setHasRedirect] = React.useState(false);
  const [logoUpload, setLogoUpload] = React.useState(false);
  const [profileLogoUpload, setProfileLogoUpload] = React.useState(false);

  const { user, setObData, obData } = useAuthContext();

  console.log(obData?.logo, obData?.profileLogo);

  // Get the onboarding data from /profile
  React.useEffect(() => {
    const _getObData = async () => {
      const token = getToken();

      try {
        const { data } = await Api.get('/profile', {
          headers: { Authorization: `Bearer ${token}` },
        });
        console.log('Retry');

        if (data.data.onboarding?.sid !== 0) {
          setObData(data.data.onboarding);
        }
      } catch (e) {
        console.log(e);
      }
    };

    // !obData || (obData?.sid === 0 && _getObData());
    _getObData();
  }, []);

  React.useEffect(() => {
    if (obData.sid !== 0 && obData.logo) _getLogoFile(obData.logo);
    if (obData.sid !== 0 && obData.profileLogo)
      _getProfileLogoFile(obData.profileLogo);
  }, [obData]);

  // Check for obData.logo and obData.profileLogo to be uploaded
  React.useEffect(() => {
    if (
      obData?.logo &&
      obData?.profileLogo &&
      logoUpload &&
      profileLogoUpload
    ) {
      setRedirecting(false);
    }

    if (obData?.logo && !obData?.profileLogo && logoUpload) {
      setRedirecting(false);
    }

    if (obData?.profileLogo && !obData?.logo && profileLogoUpload) {
      setRedirecting(false);
    }
  }, [obData?.logo, logoUpload, profileLogoUpload, obData?.profileLogo]);

  // Get sidToken from localStorage
  React.useEffect(() => {
    const sidToken = localStorage.getItem('sidToken');

    if (sidToken) {
      setToken(sidToken);
    } else {
      if (user.token) setToken(user.token);
    }

    if (import.meta.env.VITE_SITE === 'Paybilt') {
      setPrivacy('https://paybilt.com/privacy/');
      setTerms('https://paybilt.com/terms-conditions/');
    } else {
      setPrivacy('https://payper.ca/privacy');
      setTerms('https://payper.ca/terms-conditions');
    }
  }, []);

  React.useEffect(() => {
    if (user.redirect && user.redirect !== '') {
      setHasRedirect(true);
      setRedirecting(true);

      if (!obData?.logo && !obData?.profileLogo) {
        setRedirecting(false);
      }
    }
  }, [user, obData]);

  React.useEffect(() => {
    if (user.redirect && user.redirect !== '' && token) {
      console.log('Redirecting...');
      if (!wait) {
        redirect(token);
      }
    }

    if (redirectUrl !== '') {
      window.location.replace(redirectUrl);
    }

    console.log({ redirectUrl, redirect: user.redirect });
  }, [user, redirectUrl, token, wait]);

  const _getLogoFile = async (url: string) => {
    // const logo: any = localStorage.getItem('logo');
    try {
      const fileUrl = await getFile(url);

      // Generate fileUrl to multipart-formdata
      const file = await fetch(fileUrl);
      const blob = await file.blob();
      const newFile = new File([blob], 'logo.png', { type: 'image/png' });
      console.log(obData?.sid);
      await setLogos(newFile, 'logo', obData?.sid);
      console.log('Logo Updated');
    } catch (e) {
      console.log(e);
    } finally {
      setLogoUpload(true);
    }

    // if (logo) {
    //   await setLogos(logo, 'logo', obData?.sid);
    //   setRedirecting(false);
    // } else {
    //   const fileUrl = await getFile(d.logo);
    //   // I'm getting a file url I want to send this file as multipart-formdata to the backend

    //   const file = await fetch(fileUrl);
    //   const blob = await file.blob();
    //   const newFile = new File([blob], 'logo.png', { type: 'image/png' });
    //   console.log({ newFile });

    //   await setLogos(newFile, 'logo', obData?.sid);
    //   setRedirecting(false);
    // }
  };

  const _getProfileLogoFile = async (url: string) => {
    // const logo: any = localStorage.getItem('profileLogo');

    try {
      const fileUrl = await getFile(url);

      const file = await fetch(fileUrl);
      const blob = await file.blob();
      const newFile = new File([blob], 'profile_logo.png', {
        type: 'image/png',
      });
      console.log(obData?.sid);
      await setLogos(newFile, 'profile_logo', obData?.sid);
      console.log('Profile Logo Updated');
    } catch (e) {
      console.log(e);
    } finally {
      setProfileLogoUpload(true);
    }

    // if (logo) {
    //   await setLogos(logo, 'profile_logo', obData?.sid);
    //   setRedirecting(false);
    // } else {
    //   const fileUrl = await getFile(d.profileLogo);

    //   const file = await fetch(fileUrl);
    //   const blob = await file.blob();
    //   const newFile = new File([blob], 'profile_logo.png', {
    //     type: 'image/png',
    //   });
    //   console.log({ newFile });

    //   await setLogos(newFile, 'profile_logo', obData?.sid);
    //   setRedirecting(false);
    // }
  };

  const redirect = async (t: string) => {
    const authToken = getToken();

    // Reset redirect
    const { data } = await Api.put(
      '/profile',
      { redirect: '' },
      { headers: { Authorization: `Bearer ${authToken}` } }
    );

    if (data.success) {
      localStorage.removeItem('redirect');

      if (import.meta.env.VITE_SITE === 'Paybilt') {
        setRedirectUrl(
          `https://pay.paybilt.com/config/login${user.redirect}&token=${t}`
        );
      } else {
        setRedirectUrl(
          `https://pay.payper.ca/config/login${user.redirect}&token=${t}`
        );
      }
    }
  };

  console.log('More:', obData?.reqMore);

  return (
    <AuthLayout>
      <Wrap>
        <div>
          <Box mb={3}>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <img src={logo()} width={100} alt={import.meta.env.VITE_SITE} />
              <Logout />
            </Box>
          </Box>
          {!wait && !hasRedirect && obData?.reqMore ? (
            <AppCard title="Thank you for resubmitting!">
              <Typography variant="body2" sx={{ mt: 2 }}>
                You will receive an email once your application has been
                approved.
              </Typography>
            </AppCard>
          ) : (
            <AppCard
              title={
                wait || hasRedirect
                  ? ''
                  : `Welcome to ${import.meta.env.VITE_SITE}`
              }
            >
              {(wait || hasRedirect) && <Redirecting />}
              {!hasRedirect && token && <Token token={token} />}
              {!wait && !hasRedirect && !token && <Failed />}
            </AppCard>
          )}

          <Typography py={3} variant="body2" color="textSecondary">
            {'© '}
            {new Date().getFullYear()} {import.meta.env.VITE_SITE} {'.'}{' '}
            <a href={privacy} target="_blank">
              Privacy
            </a>{' '}
            &{' '}
            <a href={terms} target="_blank">
              Terms
            </a>
          </Typography>
        </div>
      </Wrap>
    </AuthLayout>
  );
};

export default Result;

// Redirecting text and spinner animation above
const Redirecting = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
      }}
    >
      <ClockLoader size={80} color="#ddd" />
      <Typography variant="h6" mt={2} color="textSecondary">
        Redirecting...
      </Typography>
      <Typography variant="body2" color="textSecondary">
        Please wait while we redirect you to your dashboard
      </Typography>
    </Box>
  );
};
